// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wnwe","select":"styles_select__1XIQa"};